<template>
  <div class="select-wrapper">
    <el-select-v2
      v-model="carSelected"
      :options="cars"
      placeholder="请选择车辆"
      filterable
      :props="{label:'carName',value:'carName',key:'carName'}"
      @change="handleCarChange"
      remote
      :remote-method="searchVehicle"
    />
    <el-tooltip
      effect="dark"
      placement="top-start"
      ref="mypop"
    >
    <template #content>支持超过8天的数据播放</template>
    <el-button size="small" class="timeSelect" @click="handleOpen" :disabled="!carSelected">选择时间</el-button>
    </el-tooltip>
    <transition name="fade">
      <div class="mySelectPopper" v-show="dialogVisible">
        <ElConfigProvider :locale="locale">
          <el-date-picker
            v-model="dateSelected"
            type="daterange"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="x"
            :locale="locale"
            style="flex: none; width: 100%; height: 30px;"
            @change="handleSelected"
            size="small"
            popper-class="time-dark-hour-box"
          />
        </ElConfigProvider>
      </div>
    </transition>
  </div>
</template>

<script lang="js">
import { defineComponent, watch, computed } from 'vue';
import router from '@/router/index';
import { store } from '@/store/index';
import { getQueryVariable, debounce } from '@/utils/utils';
import { getCarList, getVehicleList } from '@/service';
import { useFrameDataStore } from "@/store/frameDataStore";
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import { ElConfigProvider } from 'element-plus'


export default defineComponent({
  name: 'CarList',
  data() {
    return {
      cars: [],
      carSelected: null,
      dateSelected: null,
      frameDataStore: useFrameDataStore(),
      dialogVisible: false,
      locale:zhCn
    };
  },
  created() {
    this.searchVehicle = debounce(this._searchVehicle.bind(this), 300);
  },
  mounted() {
    this.init();

    watch(
      computed(() => this.carSelected),
      (car,oldCar) => {
        if (!car) {
          ElMessage.error('请先选择车辆');
        } else {
          store.commit('setLoadingText',{text:'连接成功，请在播放列表选择时间段'});
          this.frameDataStore.setCurrentVehicleId(car);
          const currentTs = this.$route.query.ts || '';
          const shouldKeepTs = !oldCar;
          router.push({
            path: '/',
            query: {
              vehicleId: car,
              ts: shouldKeepTs ? currentTs : '' // 新车时清空
            },
          });
          if(!shouldKeepTs){
            this.frameDataStore.setQueryStartTs(0)
          }
        }
      },
    );
  },
  methods: {
    init() {
      getVehicleList({ vehicle: '' }).then((res) => {
        if (res.success) {
          let cars = res.data.map(({ name, id }) => ({
            carName: name,
            vehicleId: id,
          }));
          cars.sort((item1, item2) => {
            return item1.carName > item2.carName ? 1 : -1;
          });
          this.cars = cars;
          this.carSelected = getQueryVariable('vehicleId') || null;
          let queryStartTs = getQueryVariable('ts') || null;
          if (queryStartTs) {
            this.frameDataStore.setQueryStartTs(Number(queryStartTs))
          }
        }
      });
    },
    handleOpen(){
      this.dialogVisible = !this.dialogVisible;
    },
    handleSelected(){
      this.frameDataStore.setCurrentVehicleIdAndTime(this.carSelected, this.dateSelected);
      router.push({
        path: '/',
        query: {
          vehicleId: this.carSelected,
          ts: parseInt(String(this.dateSelected[0] / 1000))
        },
      });
      this.dialogVisible = !this.dialogVisible;
      this.dateSelected = null;
    },
    handleCarChange(){
      if(getQueryVariable('ts')){
        const url = new URL(window.location.href);
        url.searchParams.set("ts", ""); // 置空值
        window.history.replaceState({}, "", url);
      }
    },
    _searchVehicle(query) {
      getVehicleList({ vehicle: query }).then((res) => {
        if (res.success) {
          this.cars = res.data.map(({ name,id }) => ({
            carName: name,
            vehicleId: id,
          }));
        }
      });
    },
    searchVehicle(query) {
      this._searchVehicle(query);
    }
  },
});
</script>
<style></style>
<style lang="less" scoped>
.fade-enter-active,  
.fade-leave-active {  
  transition: opacity 0.3s ease, transform 0.2s ease; 
}  

.fade-enter,  
.fade-leave-to {  
  opacity: 0; 
  transform: scale(0.9); 
}   
.select-wrapper {
  display:flex;
  --el-input-bg-color: rgba(255, 255, 255, 0.4) !important;
  // --el-input-text-color: #fff;
  .timeSelect {
    margin-left: 4px;
    line-height: 34px;
    height: 34px;
    background: url('@/assets/images/btn-bg.png') no-repeat;
    background-size: 100% 100%;
    border:none;
    color: #fff;
  }
  :deep(.el-input__wrapper) {
    background-color: #fff;
    border: 1px solid #f2f2f2;
  }
  .mySelectPopper {
    position: absolute;
    display: flex;
    flex-direction: column;
    // align-items: flex-end;
    justify-content: space-between;
    // align-content:center;
    padding-bottom: 10px;
    top: 60px;
    right: 0px;
    width: 180px;
    height: 60px;
    z-index: 10;
    :deep(.el-input__wrapper) {
      background-color: #0e3141;
    }
    :deep(.el-range-input::placeholder){
      color: #fff;
    }
  }
}

</style>
